import React, { Fragment } from 'react';
import PageTitle from '../../components/pagetitle';
import Footer from '../../components/footer';
import Scrollbar from '../../components/scrollbar';
import ExecutiveCommittee from '../../components/ExecutiveCommittee';

const BairaPage = () => {
  return (
    <Fragment>
      <PageTitle pageTitle={'Committee of BAIRA'} />
      <ExecutiveCommittee association='BAIRA' />
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default BairaPage;
